module.exports = __webpack_public_path__ + "img/sec03-01.bc2bb66a.png";